<template>
  <div :class="classes" v-loading="loading" v-if="order">
    <pt-page-title title="委托单详情"></pt-page-title>
    <pt-sub-title title="委托单状态" >
      <span slot="line" style="color:red;margin-left:10px;" v-if="order && order.isDelay">已延期</span>
      <pt-legend :statusArray="statusArray"></pt-legend>
    </pt-sub-title>
    <status-progress :status="nextStatus" :task="task" :operationList="operationList" :isClosed="isClosed" :isComplete="isComplete" @statusClick="statusClick"></status-progress>
    <!-- 状态操作需补充 -->
    <p v-if="isComplete || isClosed || noNeedOperateStatus" style="height:20px;"></p>
    <template v-else>
      <!-- <template v-if="order"> -->
      <order-status :status="nextStatus" :order="order" :task="task" :selectOrder="selectOrder" @polling-reload="pollingReload" @status-change="reload" @isLoading="(val)=>loading = val">
      </order-status>
      <!-- </template> -->
    </template>

    <pt-sub-title title="委托方信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p>
          <span>委托单编号：</span>
          {{order.billCode}}
        </p>
        <p>
          <span>委托方单位名称：</span>
          {{order.organization.name}}
        </p>
        <p>
          <span>通讯地址：</span>
          {{order.organization.base.address.postAddress}}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <p>
          <span>联系人：</span>
          {{order.organization.base.contact}}
        </p>
        <p>
          <span>联系电话：</span>
          {{order.organization.base.mobile}}
        </p>
        <p>
          <span>身份证号：</span>
          {{order.organization.base.cardId }}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
          <p>
            <span>E-mail：</span>
            {{ order.organization.base.email }}
          </p>
        <p>
          <span>委托单扫描件：</span>
          <a v-if="BILL_PDF" :href="$privateResourcesUrl+BILL_PDF.ossUrl" target="_blank" :class="$style.special">{{BILL_PDF.name}}</a>
          <span v-else>--</span>
        </p>
        <p>
              <span>邮寄地址：</span>
              {{ order.reportShippingAddress||'--' }}
            </p>
      </wt-box>
    </wt-grid>

    <pt-sub-title title="委托内容"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <!-- <p>
          <span>检测项目：</span>
          {{order.labExamItemList && order.labExamItemList.map(e=>e.itemName).toString()}}
        </p>
        <p>
          <span>检测依据：</span>
          {{order.examBasisList&&order.examBasisList.toString() || "--"}}
        </p>
        <p>
          <span>是否有偏离：</span>
          {{order.deviate_text}}
          {{order.deviateInfo}}
        </p> -->
        <p>
          <span>交付方式：</span>
          {{order.delivery_type || "--"}}
        </p>
        <p>
          <span>报告份数：</span>
          {{order.reportNum}}
        </p>

        <p>
          <span>开始日期：</span>
          {{order.start_date}}
        </p>

        <p>
          <span>交付日期：</span>
          {{order.delivery_date}}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
        <p>
          <span>是否返还：</span>
          {{order.back_text}}
        </p>
				<p>
          <span>是否显示全部样品名称：</span>
          {{order.isDisplayAll?'是':(order.isDisplayAll===false?'否':'--')}}
        </p>
        <p>
          <span>是否加急：</span>
          <el-tag type="danger" size="small" v-if="order.urgent"> {{order.urgent_text}}</el-tag>
          <template v-else>否</template>
        </p>
        <p>
          <span>加急费（元）：</span>
          {{order.urgentMoney || "--"}}
        </p>
        <p>
          <span>合计总金额：</span>
          {{order.billAmount || "--"}}
        </p>
      </wt-box>
      <wt-box :class="$style['order-info']">
          <p>
            <span>是否盖章：</span>
            <el-tag type="danger" size="small" v-if="order.mandateStamped"> {{ order.mandateStamped_text }}</el-tag>
            <template v-else>否</template>
          </p>
          <p>
            <span>显示生产单位：</span>
            {{ order.showProductionOrg ? '是' : (order.showProductionOrg === false ? '否' : '--') }}
          </p>
          <p>
            <span>备注：</span>
            {{ order.remarks || "--" }}
          </p>
          <p>
            <span>财务备注：</span>
            {{ order.financialNote || "--" }}
          </p>
        <!-- <p>
          <span>相关文献：</span>
          <template v-if="LITERATURE_attachments">
            <a :href="$privateResourcesUrl+item.ossUrl" target="_blank" v-for="(item,i) in LITERATURE_attachments" :key="i" :class="$style.special">{{item.name}}</a>
          </template>
          <template v-else>--</template>
        </p> -->
      </wt-box>
    </wt-grid>
    <pt-sub-title title="结算/开票/邮寄信息"></pt-sub-title>
    <wt-grid :col="1" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p style="margin-bottom:20px;">
          <span style="color:#333;">催缴：</span>
          <el-button type="primary" plain @click="callDialog=true">点击提醒缴费</el-button>
          <template v-if="order.isCall">
            <el-popover
              ref="popover"
              placement="bottom"
              title="短信内容"
              width="200"
              trigger="click"
              content="【理化中心材料化学部】您送检的样品已完成检测，确认付款后将为您发送检测结果。纸版报告如随发票快递，需到付。客服联系电话（010）58717279，（010）58711815">
            </el-popover>

            <el-button v-popover:popover type="text" style=" margin:0 20px;">查看短信内容</el-button>

            <!-- <template v-if="order.settlement"> -->
              <span style="color:#333; margin-right:20px;">
                已催缴
                <span style="color:#409eff;">
                  {{order.callCount}}
                </span>次
              </span>
              <span style="color:#333; margin-right:20px;">
                最新催缴记录：
                <span style="margin:0 10px;">
                  {{order.otherInfo && order.otherInfo.billCaller ||  '--'}}
                </span>
                {{order.otherInfo && order.otherInfo.bill_call_date ||  '--'}}
              </span>
              
              <!-- <span style="color:#6D6D6D; margin-right:20px;">{{order.otherInfo.billSettler}}</span>
              <span style="color:#6D6D6D;">{{order.otherInfo.bill_settler_date}}</span> -->
            <!-- </template> -->
          </template>
        </p>
        <p style="margin-bottom:20px;">
          <span style="color:#333;">结算：</span>
          <template v-if="order.settlement">
            <span style="color:#6D6D6D; margin-right:20px;">已结算</span>
            <span style="color:#6D6D6D; margin-right:20px;">{{order.otherInfo.billSettler}}</span>
            <span style="color:#6D6D6D; margin-right:20px;">{{order.otherInfo.bill_settler_date}}</span>
						<el-button type="primary" plain :disabled="!HAS_PERM_SETTLEMENT" @click="cancelBills('CANCEL_SETTLEMENT')">撤销结算</el-button>
          </template>

          <el-button type="primary" :disabled="!HAS_PERM_SETTLEMENT" v-else plain @click="handleSettle">确认已结算</el-button>
        </p>
        <p style="margin-bottom:20px;">
          <span style="color:#333" >开票：</span>
          <template v-if="order.invoice">
            <a :href="$privateResourcesUrl+item.ossUrl" target="_blank" v-for="(item,i) in INVOICE_PICTURE_attachments" :key="i" :class="$style.special">{{item.name}}</a>
            <span style="color:#6D6D6D; margin-right:20px;">{{order.otherInfo.billDrawer}}</span>
            <span style="color:#6D6D6D; margin-right:20px;">{{order.otherInfo.bill_drawer_date}}</span>
					<el-button type="primary" plain :disabled="!HAS_PERM_INVOICE" @click="cancelBills('CANCEL_INVOICE')">撤销开票</el-button>
          </template>
          <el-button v-else type="primary" :disabled="!HAS_PERM_INVOICE" plain @click="handleInvoice">确认已开票</el-button>
        </p>
				<p v-if="order.invoice" style="margin-bottom:20px;">
					<span style="color:#333;">快递单号：</span>
					<template>
						{{order.otherInfo.billDrawerExpressCode}}
					</template>
				</p>
        <p style="margin-bottom:20px;">
            <span style="color:#333;">报告邮寄：</span>
            <template v-if="order.isMailed">
              <span style="color:#6D6D6D; margin-right:20px;">{{ order.otherInfo.billMailed }}</span>
              <span style="color:#6D6D6D; margin-right:20px;">{{ order.otherInfo.bill_mailed_date }}</span>
  					<el-button type="primary" plain :disabled="!HAS_PERM_INVOICE" @click="cancelBills('CANCEL_MAILED')">撤销邮寄</el-button>
            </template>
            <el-button v-else type="primary" :disabled="!HAS_PERM_INVOICE" plain @click="handleMailed">确认已邮寄</el-button>
        </p>
      </wt-box>
    </wt-grid>
    <!-- <pt-sub-title title="样品信息"></pt-sub-title>
    <base-table selectType="" border :columns="tableLabels" :spanMethod="spanMethod" :table-data="sampleCompareData || []"></base-table> -->
    <div class="dashed" />
    <combine-tab-list ref="tabList" :needRefreshOrder="needRefreshOrder" :labExamItemList="order.labExamItemList" :isComplete="isComplete" :billId="order.id" :billCode="order.billCode" @reload="reload" @select-order-change="getSelectOrder" :canSelect="true" comePage="billDetail">
    </combine-tab-list>
    <div class="button-div">
			<el-button type="danger" plain v-if="isClosed" @click="goDelete">删除委托单</el-button>
			<template  v-if="!isClosed">
				<el-button type="primary" @click="goEdit">编辑委托单</el-button>
      <el-button type="danger" v-if="!isComplete" plain @click="closeBill">关闭委托单</el-button>
			</template>
    </div>
    <!-- 开票 -->
    <trustDeedInvoiceDialog :dialogVisible="showDialog" @close="showDialog = false" :selectData="[order]" @reload="reload"></trustDeedInvoiceDialog>
    <!-- 催缴 -->
    <callNoticeDialog :billId="order.id" :dialogVisible="callDialog" @close="callDialog = false" @reload="reload"></callNoticeDialog>
  </div>
</template>

<script>
import ptLegend from 'cps/base/pt-legend'
import statusProgress from '../../common/status-progress.vue'
import orderStatus from 'cps/trust-deed/order-status'
import combineTabList from 'cps/common/combine-tab-list'
import { statusArray, tableLabels } from './options'
import trustDeedInvoiceDialog from 'cps/common/trust-deed-invoice-dialog'
import callNoticeDialog from './call-notice-dialog.vue'
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-trust-deed-detail'

export default {
  name: 'pt-trust-deed-detail',
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    needRefreshOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_PERM_SETTLEMENT () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_06')
      return M_PERM || SETTLEMENT_PERM
    },
    HAS_PERM_INVOICE () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_B_07')
      return M_PERM || SETTLEMENT_PERM
    },
    isClosed () {
      return this.order && this.order.billStatusEnum === 'BILL_CLOSE'
    },
    isComplete () {
      return this.order && this.order?.nextBillAction === 'NONE'
    },

    noNeedOperateStatus () {
      let noNeedOperateStatus = ['BILL_BACK','BILL_RECEIVE']
      return noNeedOperateStatus.includes(this.order.nextBillAction)
    },
    operationList () {
      return this.order?.historyStatus.map(e => {
        const { action, statusTime, auditInformation } = e
        return {
          status: action,
          statusTime,
          auditInformation
        }
      })
    },
    LITERATURE_attachments () {
      return this.order?.attachments?.filter(e => e.type === 'LITERATURE')
    },
    INVOICE_PICTURE_attachments () {
      return this.order?.attachments?.filter(e => e.type === 'INVOICE_PICTURE')
    },
    BILL_PDF () {
      return this.order?.attachments?.find(e => e.type === 'BILL_PDF_BACK')
    },
    sampleCompareData () {
      const orderSummaryList = this.order.orderSummaryList?.map(e => {
        return {
          sampleType: '汇总样品信息',
          ...e
        }
      }) || []
      const preOrderSummaryList = this.order.preOrderSummaryList?.map(e => {
        return {
          sampleType: '协议样品信息',
          ...e
        }
      }) || []
      return orderSummaryList.concat(preOrderSummaryList)
    }
  },
  components: {
    ptLegend,
    statusProgress,
    orderStatus,
    combineTabList,
    trustDeedInvoiceDialog,
    callNoticeDialog
  },
  data () {
    return {
      statusArray,
      tableLabels,
      nextStatus: this.order?.nextBillAction,
      warningInfo: '',
      // task:{
      //   orderActionData:{
      //     nextActionResults:['CHONG_XIN_TI_GONG_YANG_PIN','ZHONG_ZHI','FEI_QI','HUI_FU'],
      //     action:'STEP_THREE'
      //   }
      // },
      task: null,
      loading: false,
      showDialog: false,
      selectOrder: [],
      callDialog: false
    }
  },
  watch: {
    'order.nextBillAction': {
      handler: function (val) {
        this.nextStatus = val
      }
    },
    'order.futureTasks': {
      handler: function (val) {
        this.task = val?.find(e => e.billActionData?.action === this.nextStatus)
      }
    },
    'nextStatus': {
      handler: function (val) {
        this.task = this.order.futureTasks?.find(e => e.billActionData?.action === val)
      }
    }
  },
  methods: {
		cancelBills(type){
				let text=''
				switch(type){
					case 'CANCEL_INVOICE':
						text='开票'
						break
					case 'CANCEL_SETTLEMENT':
						text='结算'
						break
					default:
						break
				}
			this.$confirm(`是否确认撤销${text}`,`撤销${text}`,{
				confirmButtonText: '确认',
        cancelButtonText: '取消'
			}).then(_=>{
			this.$emit('cancelBills',type,text)
			})
		},
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.order.orderSummaryList?.length && this.order.preOrderSummaryList?.length) {
        if (rowIndex === 0) {
          return {
            rowspan: this.order.orderSummaryList?.length,
            colspan: 1
          }
        } else if (rowIndex === this.order.orderSummaryList?.length) {
          return {
            rowspan: this.order.preOrderSummaryList?.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    statusClick (item) {
      const canClickStatus = ['BILL_RECEIVE', 'BILL_ASSIGN', 'BILL_EXECUTE']
      if (canClickStatus.includes(item.name)) {
        this.nextStatus = item.name
      }
    },
    handleSettle () {
      this.$confirm(`该委托单是否“确认已结算”?`, '确认已结算', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        let data = {
          ids: [this.order.id]
        }
        this.$store.dispatch('handleSettle', data).then(res => {
          this.loading = false
          this.$message.success('操作成功')
          this.reload()
        }).catch(err => {
          this.loading = false
          this.$message.warning(err || '操作失败')
        })
      })
    },
    handleInvoice () {
      this.showDialog = true
    },
    handleMailed () {
      this.$confirm(`请确认是否已邮寄报告`, '确认邮寄', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        let data = {
          ids: [this.order.id],
          operType: 'MAILED'
        }
          this.loading = true
          this.$store.dispatch('handleMailed', data).then(res => {
            this.$message.success('确认邮寄成功')
            this.reload()
            this.cancel()
          }).catch(err => {
            this.$message.warning(err || '操作失败')
          }).finally(() => {
            this.loading = false
          })
      })
    },
		goDelete(){
      this.$confirm(`是否确认删除该委托单，删除后将不可恢复！`, '确认删除委托单', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteBill', this.order.id).then(res => {
          this.$message.success('操作成功')
          this.$router.push('/trust-deed-list')
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.loading = false
        })
      })
		},
    goEdit () {
      this.$router.push(`/trust-deed-form/true/${this.order.id}`)
    },
    reload (statusResult) {
      this.$refs.tabList.reload()
      this.$emit('on-reload',statusResult)
    },
    pollingReload () {
      this.$emit('polling-reload')
    },
    closeBill () {
      this.$confirm(`是否确认关闭该委托单？`, '确认关闭委托单', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('closeBill', this.order.id).then(res => {
          this.$message.success('操作成功')
          this.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.loading = false
        })
      })
    },
    getSelectOrder (datas) {
      console.log('----datas', datas)
      this.selectOrder = datas
    }
  }
}
</script>

<style module lang="less">
@import "~less/var.less";

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.order-info__box {
  padding: 10px 20px;
}
.order-info-file__list {
  display: flex;
  padding: 10px 20px;
  :global {
    a {
      margin-left: 10px;
    }
    div {
      a {
        padding: 10px 0;
        display: block;
      }
    }
  }
}
.order-info {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color:#6D6D6D;

  > p >span:not(:global .el-tag) {
    font-size: 14px;
    color: @mainColor;
    line-height: 30px;

  }
  a{
    margin-right:20px;
    vertical-align:middle;
    color: @mainColor;
  }
}

.order-info > div {
  span {
    display: block;
  }
}
</style>
